// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-xsmall-badge-2f4e7810"};